<div class="pb-4">
  <button
    *ngIf="isShowCreateButton()"
    class="btn btn-primary mt-4"
    data-test-id="item-create-btn"
    (click)="createItem()"
    [disabled]="isExpired"
    type="button"
    aria-labelledby="Create button"
  >
    {{ itemsListContent?.createItemInfo?.createItemTitle | translate }}
  </button>
</div>

<ng-container *ngIf="items.length; then list; else emptyListHint"></ng-container>

<ng-template #list>
  <div class="row">
    <div class="col-md-6 mb-4" *ngFor="let item of items; index as i">
      <app-card
        [data]="item"
        [index]="i"
        [type]="type"
        [redirectToLoginIfNoSession]="redirectToLoginIfNoSession"
      ></app-card>
    </div>
  </div>
  <div
    *ngIf="searchState?.pagination?.totalItemsCount > defaultCount"
    class="pagination-holder"
    data-test-id="pagination-holder"
  >
    <ngb-pagination
      class="w-100 d-flex justify-content-center pagination custom-pagination"
      data-test-id="pagination-box"
      [class.pagination-sm]="innerWidth <= mobileScreenWidth"
      [class.pt-3]="innerWidth <= mobileScreenWidth"
      [collectionSize]="searchState.pagination.totalItemsCount"
      [(page)]="searchState.pagination.currentPage"
      [maxSize]="3"
      [pageSize]="defaultCount"
      [rotate]="true"
      (pageChange)="onPageChanged($event)"
    ></ngb-pagination>
  </div>
</ng-template>

<ng-template #emptyListHint>
  <h4 class="pt-1 pb-4" data-test-id="no-items-hint">
    {{ noItemsTitle | translate }}
  </h4>
</ng-template>
